var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_c('input')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }